// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bell-widget-dd {
    position: relative;
    display: inline-block;
    text-align: left;
    width: 100%;
    height: 36px;
}

.bell-widget-dd-btn {
    display: inline-flex;
    justify-content: space-between;
    align-items: center;

    width: 100%;

    border: none;
    padding: 8px 8px 8px 12px;
    background-color: transparent;

    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;

    &:hover {
        background-color: rgba(0, 0, 0, 0.12);
    }

    &:focus {
        background-color: rgba(0, 0, 0, 0.22);
    }
}

.bell-widget-dd-btn-item-container {
    display: flex;
    align-items: center;
    gap: 6px;
}

.bell-widget-dd-btn-item-icon {
    width: 16px;
    height: 16px;
}

.bell-widget-dd-item-label {
    font-family: 'Arial', 'Helvetica', 'Sans-serif';
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    color: #000000;
}

.bell-widget-dd-menu {
    box-sizing: border-box;
    transform-origin: top right;
    position: absolute;
    z-index: 10;

    margin-right: 10px;
    width: 100%;

    border-radius: 4px;
    border: 0.5px solid #BDBDBD;
    box-shadow: 0px 4px 8px 0px #0000001A;

    background-color: #fff;
    outline: none;
    overflow: hidden;
}

.bell-widget-dd-item-button {
    width: 100%;

    border: none;
    background-color: #FFFFFF;
}

.bell-widget-dd-item-button {
    display: block;
    width: 100%;
    text-align: left;
    padding: 5px 12px;

    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-duration: 150ms;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
        background-color: rgba(0, 0, 0, 0.12);
    }

    &:focus {
        background-color: rgba(0, 0, 0, 0.22);
    }
}

.bell-widget-dd-opts-item-container {
    display: flex;
    align-items: center;
    gap: 6px;
}

.bell-widget-dd-opts-item-icon {
    width: 16px;
    height: 16px;
}

.bell-widget-dd-btn-item-label,
.bell-widget-dd-opts-item-label {
    font-family: 'Arial', 'Helvetica', 'Sans-serif';
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    color: #000000;
}`, "",{"version":3,"sources":["webpack://./src/Components/Common/Dropdown/Dropdown.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,8BAA8B;IAC9B,mBAAmB;;IAEnB,WAAW;;IAEX,YAAY;IACZ,yBAAyB;IACzB,6BAA6B;;IAE7B,wBAAwB;IACxB,wDAAwD;IACxD,0BAA0B;;IAE1B;QACI,qCAAqC;IACzC;;IAEA;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,+CAA+C;IAC/C,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,WAAW;;IAEX,kBAAkB;IAClB,WAAW;;IAEX,kBAAkB;IAClB,2BAA2B;IAC3B,qCAAqC;;IAErC,sBAAsB;IACtB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,WAAW;;IAEX,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iBAAiB;;IAEjB,+FAA+F;IAC/F,0BAA0B;IAC1B,wDAAwD;;IAExD;QACI,qCAAqC;IACzC;;IAEA;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,+CAA+C;IAC/C,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB","sourcesContent":[".bell-widget-dd {\n    position: relative;\n    display: inline-block;\n    text-align: left;\n    width: 100%;\n    height: 36px;\n}\n\n.bell-widget-dd-btn {\n    display: inline-flex;\n    justify-content: space-between;\n    align-items: center;\n\n    width: 100%;\n\n    border: none;\n    padding: 8px 8px 8px 12px;\n    background-color: transparent;\n\n    transition-property: all;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n    transition-duration: 150ms;\n\n    &:hover {\n        background-color: rgba(0, 0, 0, 0.12);\n    }\n\n    &:focus {\n        background-color: rgba(0, 0, 0, 0.22);\n    }\n}\n\n.bell-widget-dd-btn-item-container {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.bell-widget-dd-btn-item-icon {\n    width: 16px;\n    height: 16px;\n}\n\n.bell-widget-dd-item-label {\n    font-family: 'Arial', 'Helvetica', 'Sans-serif';\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 20px;\n    color: #000000;\n}\n\n.bell-widget-dd-menu {\n    box-sizing: border-box;\n    transform-origin: top right;\n    position: absolute;\n    z-index: 10;\n\n    margin-right: 10px;\n    width: 100%;\n\n    border-radius: 4px;\n    border: 0.5px solid #BDBDBD;\n    box-shadow: 0px 4px 8px 0px #0000001A;\n\n    background-color: #fff;\n    outline: none;\n    overflow: hidden;\n}\n\n.bell-widget-dd-item-button {\n    width: 100%;\n\n    border: none;\n    background-color: #FFFFFF;\n}\n\n.bell-widget-dd-item-button {\n    display: block;\n    width: 100%;\n    text-align: left;\n    padding: 5px 12px;\n\n    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;\n    transition-duration: 150ms;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n\n    &:hover {\n        background-color: rgba(0, 0, 0, 0.12);\n    }\n\n    &:focus {\n        background-color: rgba(0, 0, 0, 0.22);\n    }\n}\n\n.bell-widget-dd-opts-item-container {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.bell-widget-dd-opts-item-icon {\n    width: 16px;\n    height: 16px;\n}\n\n.bell-widget-dd-btn-item-label,\n.bell-widget-dd-opts-item-label {\n    font-family: 'Arial', 'Helvetica', 'Sans-serif';\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 20px;\n    color: #000000;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
